// extracted by mini-css-extract-plugin
module.exports = {"root":"TalentAnalysisToolTable_root__Vz6OU","toolTableContainer":"TalentAnalysisToolTable_toolTableContainer__UQzkm"};